import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { GlobalModule } from '../global/global.module';
import { ResponsiveService } from './responsive.service';

@NgModule({
  imports: [
  ],
  providers: [
    ResponsiveService
  ]
})
export class ResponsiveModule {
}



// WEBPACK FOOTER //
// ./src/app/responsive/responsive.module.ts